import type {PerseusIFrameWidgetOptions} from "../../data-schema";

export function getIFramePublicWidgetOptions(
    options: PerseusIFrameWidgetOptions,
): PerseusIFrameWidgetOptions {
    return options;
}
